module.exports = __webpack_public_path__ + "static/media/16.93e4e797.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/16.png
// module id = 933
// module chunks = 0